import mergeClasses from '../../../utils/shallowMerge';
import defaultClasses from './ImageTeaser.module.scss';
import { TeaserContent } from './TeaserContent';
import { TeaserMedia } from './TeaserMedia';
import PropTypes from 'prop-types';
import React from 'react';
import { useMedia } from 'react-use';
import { useSelector } from 'react-redux';

import clsx from 'clsx';
import { Link } from '../../atoms/link/Link';

const ImageTeaser = ({
  image = null,
  isMain = false,
  label = '',
  labelStyles,
  title = '',
  titleStyles,
  subtitle = '',
  subTitleStyles,
  accentText = false,
  spacing = 'none', // none, large, medium, small
  button = '',
  mobileButton = '',
  background = 'none',
  verticalPosition = 'center', // top, center, bottom
  horizontalPosition = 'center', // left center right
  textAlign = 'center', // left center right
  onAboutUsPage,
  hideImageOnMobile = false,
  hideOnMobile = false,
  isOverlay,
  overlayTheme,
  videoUrl = null,
  isLinkCovered = false,
  link = null,
  customClasses = null,
  heightStyles,
  isMobile,
  imageMobile,
  videoUrlMobile,
  layoutType = 'transprentOverlay',
  mediaLoading,
  preloadImage = false,
  showVideoControls,
}) => {
  const styles = mergeClasses(defaultClasses, customClasses);
  const isSm = useMedia('(max-width: 640px)', false);
  const isXl = useMedia('(min-width: 1441px)', true);
  if (isSm && hideOnMobile) return null;

  const childrenNode = (
    <div
      className={clsx(styles.root, styles[`layout_${layoutType}`])}
      style={{ ...heightStyles }}
    >
      <TeaserMedia
        preloadImage={preloadImage}
        isMobile={isMobile}
        image={image}
        spacing={spacing}
        background={background}
        onAboutUsPage={onAboutUsPage}
        hideImageOnMobile={hideImageOnMobile}
        video={videoUrl}
        imageMobile={imageMobile}
        videoMobile={videoUrlMobile}
        styles={styles}
        breakpoint={{
          small: isSm,
          large: isXl,
        }}
        isOverlay={isOverlay}
        showVideoControls={showVideoControls}
        overlayTheme={overlayTheme}
        mediaLoading={mediaLoading}
      />

      <TeaserContent
        layoutType={layoutType}
        isMain={isMain}
        label={label}
        labelStyles={labelStyles}
        title={title}
        titleStyles={titleStyles}
        subtitle={subtitle}
        subTitleStyles={subTitleStyles}
        accentText={accentText}
        button={button}
        isOverlay={isOverlay}
        overlayTheme={overlayTheme}
        mobileButton={mobileButton}
        verticalPosition={verticalPosition}
        horizontalPosition={horizontalPosition}
        textAlign={textAlign}
        styles={styles}
        breakpoint={{
          small: isSm,
          large: isXl,
        }}
      />
    </div>
  );

  return isLinkCovered && link ? (
    <Link ariaLabel="Image teaser" link={{ reference: link }} className={styles.linkWrap}>
      {childrenNode}
    </Link>
  ) : (
    childrenNode
  );
};

export default ImageTeaser;

ImageTeaser.propTypes = {
  verticalPosition: PropTypes.oneOf(['top', 'center', 'bottom']),
  horizontalPosition: PropTypes.oneOf(['left', 'center', 'right']),
  textAlign: PropTypes.oneOf(['left', 'center', 'right']),
  spacing: PropTypes.oneOf(['large', 'medium', 'small', 'none']),
  background: PropTypes.string,
  hideImageOnMobile: PropTypes.bool,
  hideOnMobile: PropTypes.bool,
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
  }),
  isMain: PropTypes.bool,
  label: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  accentText: PropTypes.bool,
  button: PropTypes.node,
  mobileButton: PropTypes.node,
  isLinkCovered: PropTypes.bool,
  link: PropTypes.object,
  videoUrl: PropTypes.string,
  customClasses: PropTypes.shape({
    root: PropTypes.string,
    wrapper: PropTypes.string,
    image: PropTypes.string,
    box: PropTypes.string,
    textBox: PropTypes.string,
  }),
  preloadImage: PropTypes.bool,
};
